import React from 'react';
import {
  ContextMenuTrigger
} from 'react-contextmenu';
import Wrapper from './styled';

const ContextMenuButton = ({
  opened, menu, trigger, display, icon
}) => {
  if (!display) return null;
  return (
    <Wrapper>
      <ContextMenuTrigger id={ trigger } holdToDisplay={ opened ? -1 : 0 }>
        {icon}
      </ContextMenuTrigger>
      {menu}
    </Wrapper>
  );
};

export default ContextMenuButton;
